<template>
    <div class="body">
		<div class="search-box">

			<div style="margin-left: 16px">
				<span class="title">课程：</span>
				<el-select @change="search" class="search-input" filterable v-model="crsId" placeholder="请选择课程">
					<el-option
							v-for="item in crsDataList"
							:key="item.id"
							:label="item.name"
							:value="item.id">
					</el-option>
				</el-select>
			</div>
			<div style='margin-left: 16px'>
				<span class="title">姓名/手机号/身份证/学号：</span>
				<el-input class="search-input"  v-model="searchData" placeholder="请输入姓名/手机号/身份证/学号" clearable @change="search"></el-input>
			</div>
			<div class='margin-left-30'>
				<el-button class="primary-btn" @click="reset()">重置</el-button>
				<el-button type="primary" style="margin-left: 16px" @click="search()">查询</el-button>
			</div>
		</div>

        <div class="container">
			<div class="tab-box">
<!--				<div class="tab" style="margin-left: 0px">{{grade}}</div>-->
				<div class="tab" style="margin-left: 0px">{{majorName}}</div>
				<div class="tab">{{semesterName}}</div>
                <el-button
                    type="primary"
                    @click="exportStuScore()"
                >导出学生成绩</el-button>
                <el-button
                    type="primary"
                    @click="showProgress"
                >查看进度</el-button>
			</div>
            <div class="table-cls">
                <el-table
                    :data="tableData"
                    class="table"
                    border
					@sort-change="sortChange"
					:cell-style="{color:'#666666',fontSize:'14px',height: '50px'}"
					:header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500,fontSize:'14px'}">
                    <el-table-column prop="crs_id" align="center" label="课程">
						<template slot-scope="scope">
							{{crsDataHash[scope.row.crs_id]}}
						</template>
					</el-table-column>
                    <el-table-column prop="name"  align="center"  label="姓名"></el-table-column>
                    <el-table-column prop="phone" align='center' label="手机号"></el-table-column>
                    <el-table-column prop="id_card" align='center' label="身份证"></el-table-column>
					<el-table-column prop="stu_id" align="center"  label="学号"></el-table-column>
					<el-table-column prop="video_score" align="center" sortable="custom" width="120px" label="视频成绩">

					</el-table-column>
					<el-table-column prop="homework_score" align="center" sortable="custom" width="120px" label="作业成绩"></el-table-column>
					<el-table-column prop="test_score" align="center" sortable="custom" width="120px" label="考试成绩"></el-table-column>
                    <el-table-column prop="offline_score" align="center" sortable="custom" width="120px" label="线下成绩">
                        <template slot-scope="scope">

                            <div v-if='scope.row.crs_id == 493'>
                                <div>
                                    及格
                                </div>
                            </div>

                            <div v-else
                            >
                                {{ scope.row.offline_score }}
                            </div>
                        </template>
                    </el-table-column>
					<el-table-column prop="total" align="center" sortable="custom" width="120px" label="总分">
							<template slot-scope="scope">
                                <div v-if='scope.row.crs_id == 493'>
                                    <div class="color-green">
                                        及格
                                    </div>
                                </div>

                                <div v-else>
                                    <div :class="scope.row.total>=80?'color-blue':scope.row.total<60?'color-red':'color-green'">{{scope.row.total}}</div>
                                </div>

                        	</template>

					</el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page=pageIndex
                    :page-size=10
                    :total=pageTotal
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
	import { isBlank} from '../../utils/util';
    export default {
    name: 'CourseResult',
    data() {
        return {
			searchData:'',
            detailData:[],
			performanceData:[],
            pageIndex: 1,
            pageSize: 10,
            pageTotal:0,
            tableData: [],
			content:'',
			grade:0,
			major_id:0,
			semester:0,
			org:0,
            phone:0,
			semester_id:0,
			majorName:'',
			crsDataHash:[],
			crsDataList:[],
			crsId:0,
			accountOrg:0,
			orderKey:'',
			orderState:''
        };
    },
    created() {
		this.accountOrg = localStorage.getItem("org")
		this.grade = this.$route.query.grade
    	this.major_id = this.$route.query.major_id
    	this.semester = this.$route.query.semester
    	this.org = this.$route.query.org
		this.semester_id = this.$route.query.semester_id
		this.majorName = this.$route.query.majorName
		this.semesterName = this.$route.query.semesterName
		this.crsDataList = this.$route.query.crsData
		this.crsDataList = JSON.parse(this.crsDataList)

		this.crsId = parseInt(this.$route.query.crsId)
		this.getData();
		this.getCrsData()
    },
	watch: {
		$route () {
			this.grade = this.$route.query.grade
			this.major_id = this.$route.query.major_id
			this.semester = this.$route.query.semester
			this.org = this.$route.query.org
			this.semester_id = this.$route.query.semester_id
			this.majorName = this.$route.query.majorName
			this.semesterName = this.$route.query.semesterName
			this.crsDataList = this.$route.query.crsData
			this.crsDataList = JSON.parse(this.crsDataList)
			this.crsId = parseInt(this.$route.query.crsId)
			this.getCrsData()
			this.getData();
		}
	},
    methods: {
    	search(){
			if(this.orderKey !=='' && this.orderState !=='' && this.orderState !== null ){
				this.getSortData()
			}else {
				this.getData();
			}
		},
		sortChange(e){
			this.orderKey = e.prop

			if(e.order == 'ascending'){
				this.orderState = false
				this.getSortData()
			}else if(e.order == 'descending'){
				this.orderState = true
				this.getSortData()
			}else{
				this.orderState = ''
				this.orderKey = ''
				this.getData()
				return	false
			}
		},
		getSortData(){
			this.$get(this.BASEURL+`/achievement/cousre/score/order?order_state=${this.orderState}&order_key=${this.orderKey}&page=${this.pageIndex}&grade=${this.grade}&crs_id=${this.crsId}&major_id=${this.major_id}&semester_id=${this.semester_id}&content=${this.searchData}`).then((res)=>{
				if(res.code === 200){
					this.tableData = res.data
					this.pageTotal = res.total
				}else{
					console.log(res.error);
				}
			});
		},
        exportStuScore() {
            this.$post(this.BASEURL + '/achievement/export/stu/score', {
                grade: this.grade,
                major_id: this.major_id,
                semester_id: this.semester_id,
                semesterName: this.semesterName
            }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                    // window.open(res.file_url)
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        showProgress() {
            this.$router.push({ path: '/task' });
        },
		reset(){
			this.crsId = parseInt(this.$route.query.crsId)
			this.searchData = ''

			if(this.orderKey !=='' && this.orderState !=='' && this.orderState !== null ){
				this.getSortData()
			}else {
				this.getData();
			}
		},
		getData() {
			this.$get(this.BASEURL+`/achievement/cousre/score/GET?page=${this.pageIndex}&grade=${this.grade}&crs_id=${this.crsId}&major_id=${this.major_id}&semester_id=${this.semester_id}&content=${this.searchData}`).then((res)=>{
				if(res.code === 200){
				    this.tableData = res.data
					this.pageTotal = res.total
				}else{
					console.log(res.error);
				}
			});
		},
		//获取课程列表
		getCrsData() {
			this.$get(this.BASEURL+'/tution/course/GET').then((res)=>{
				if(res.code === 200){
					let hash = []
					let arr = []
					for(let i = 0; i <res.crsData.length; i++ ){
						if (this.crsDataList.indexOf(res.crsData[i].id)>= 0){
							arr.push(res.crsData[i])
						}
					}
					this.crsDataList = arr

					this.crsDataList.forEach((item,index)=>{
						hash[item.id] = item.name
					})
					this.crsDataHash = hash
				}else{
					console.log(res.error);
				}
			});
		},
		handlePageChange(val) {
			this.pageIndex = val

			if(this.orderKey !=='' && this.orderState !=='' && this.orderState !== null ){
				this.getSortData()
			}else {
				this.getData();
			}
		},
    }
};
</script>

<style lang="scss" scoped>
	.body{
		button{
			padding: 8px 15px;
			font-size: 14px;
		}
	}

	/deep/ .cell .el-input-number{
		width: 60px;
	}

	.search-box{
		background-color: #ffffff;
		display: flex;
		align-items: center;
		padding: 28px 30px;
		margin-top: $distance;
		margin-bottom: $distance;
		border-radius: $radius;
		.search-input{
			width: 240px;
		}
		.title{
			font-size:$title-size;
			line-height:15px;
			color: #343434;
		}
	}
	.tab-box{
		display: flex;
		align-items: center;
		margin-bottom: 28px;
		.tab{
			color: #666666;
			font-size: 14px;
			text-align: center;
			padding: 0 20px;
			height: 32px;
			line-height: 32px;
			background-color: #F5F7FA;
			margin-left: 16px;
			border-radius: 5px;
		}
	}

	.primary-btn{
	    border-color: #409EFF;
	    color: #409EFF;
	}
</style>
